<template>
  <sk-layouts>
    <index-en></index-en>
  </sk-layouts>
</template>

<script>
import IndexEn from '@/components/indexEn.vue'
export default {
  props: [],
  components: {
    IndexEn,
  },
  mixins: [],
  data() {
    return {}
  },
  mounted() {},
  created() {},
  watch: {},
  computed: {},
  filters: {},
  methods: {},
}
</script>
